export default __webpack_public_path__ + "static/media/LogoMoguRemove.0f0aea4b.png";